import { db } from "../../firebase/config";
import { doc, getDoc } from "firebase/firestore";

/**
 * Envoie une notification par email à l'agriculteur lorsque son compte est approuvé
 * @param {string} farmerId - ID de l'agriculteur
 * @returns {Promise<Object>} Résultat de l'opération
 */
export const sendApprovalNotification = async (farmerId) => {
  try {
    // Récupérer les informations de l'agriculteur
    const farmerRef = doc(db, "farmers", farmerId);
    const farmerDoc = await getDoc(farmerRef);
    
    if (!farmerDoc.exists()) {
      return {
        success: false,
        message: "Agriculteur non trouvé"
      };
    }
    
    const farmerData = farmerDoc.data();
    
    // Dans une application réelle, vous utiliseriez un service d'envoi d'emails
    // comme Firebase Cloud Functions + Nodemailer, SendGrid, etc.
    // Ici, nous simulons l'envoi d'un email
    console.log(`Notification d'approbation envoyée à ${farmerData.email}`);
    
    return {
      success: true,
      message: "Notification d'approbation envoyée avec succès"
    };
  } catch (error) {
    console.error("Erreur lors de l'envoi de la notification d'approbation:", error);
    return {
      success: false,
      message: "Erreur lors de l'envoi de la notification: " + error.message
    };
  }
};

/**
 * Envoie une notification par email à l'agriculteur lorsque son compte est rejeté
 * @param {string} farmerId - ID de l'agriculteur
 * @param {string} reason - Raison du rejet
 * @returns {Promise<Object>} Résultat de l'opération
 */
export const sendRejectionNotification = async (farmerId, reason = "") => {
  try {
    // Récupérer les informations de l'agriculteur
    const farmerRef = doc(db, "farmers", farmerId);
    const farmerDoc = await getDoc(farmerRef);
    
    if (!farmerDoc.exists()) {
      return {
        success: false,
        message: "Agriculteur non trouvé"
      };
    }
    
    const farmerData = farmerDoc.data();
    
    // Dans une application réelle, vous utiliseriez un service d'envoi d'emails
    // comme Firebase Cloud Functions + Nodemailer, SendGrid, etc.
    // Ici, nous simulons l'envoi d'un email
    console.log(`Notification de rejet envoyée à ${farmerData.email}. Raison: ${reason || 'Non spécifiée'}`);
    
    return {
      success: true,
      message: "Notification de rejet envoyée avec succès"
    };
  } catch (error) {
    console.error("Erreur lors de l'envoi de la notification de rejet:", error);
    return {
      success: false,
      message: "Erreur lors de l'envoi de la notification: " + error.message
    };
  }
};